import styled, { css } from 'styled-components';

import { BlueButton } from '..';

export const EmptyStateContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme: { spacers } }): string => `${spacers!.spacer09} ${spacers!.spacer03}`};
  font-family: InspireTWDC;
`;

export const Title = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    color: ${admanColors!.gray.light.fg1[0]};
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: ${spacers!.spacer02};
  `
);

export const ClearFiltersButton = styled(BlueButton)`
  height: 32px;
  font-size: 14px;
`;

export const SubTitle = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    color: ${admanColors!.gray.light.fg1[0]};
    font-size: 14px;
    line-height: 21px;
    margin-bottom: ${spacers!.spacer02};
    white-space: pre-line;
    text-align: center;
  `
);
